import { render, staticRenderFns } from "./adult.vue?vue&type=template&id=6188c84c&scoped=true"
import script from "./adult.vue?vue&type=script&lang=js"
export * from "./adult.vue?vue&type=script&lang=js"
import style0 from "./adult.vue?vue&type=style&index=0&id=6188c84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188c84c",
  null
  
)

export default component.exports